export const manifest = {
  screens: {
    scr_haiat8: { name: "Splash", route: "/splash", state: {"session":"newUser"}, position: {"x":160,"y":220} },
    scr_vw8blx: { name: "Language", route: "/idioma", state: {"session":"newUser"}, position: {"x":1560,"y":220} },
    scr_xub3oe: { name: "Login", route: "/entrar", state: {"session":"newUser"}, position: {"x":160,"y":2200} },
    scr_gmstpe: { name: "Create Account", route: "/criar-conta", state: {"session":"newUser"}, position: {"x":1560,"y":2200} },
    scr_qzzu98: { name: "Forgot Password", route: "/recuperar", state: {"session":"newUser"}, position: {"x":2960,"y":2200} },
    scr_87biud: { name: "Account Confirmation", route: "/confirmar-conta", state: {"session":"newUser"}, position: {"x":4360,"y":2200} },
    scr_kul27o: { name: "Onboarding · Intro", route: "/onboarding", state: {"session":"newUser"}, position: {"x":160,"y":4180} },
    scr_wv5vhi: { name: "Onboarding · Goals", route: "/onboarding/objetivos", state: {"session":"newUser"}, position: {"x":1560,"y":4180} },
    scr_qa8zqt: { name: "Onboarding · Activities", route: "/onboarding/atividades", state: {"session":"newUser"}, position: {"x":2960,"y":4180} },
    scr_skbrwk: { name: "Onboarding · Preferences", route: "/onboarding/preferencias", state: {"session":"newUser"}, position: {"x":4360,"y":4180} },
    scr_3ft68j: { name: "Onboarding · Permissions", route: "/onboarding/permissoes", state: {"session":"newUser"}, position: {"x":5760,"y":4180} },
    scr_6wfrz7: { name: "Onboarding · First Check", route: "/onboarding/primeiro-check", state: {"session":"newUser","dayState":"firstUse"}, position: {"x":8560,"y":4180} },
    scr_9ufhsf: { name: "Onboarding · Complete", route: "/onboarding/pronto", state: {"session":"newUser"}, position: {"x":7160,"y":4180} },
    scr_3xmww3: { name: "Home · Default", route: "/", state: {"dayState":"inProgress"}, position: {"x":160,"y":6160} },
    scr_nuvdw7: { name: "Home · Low Energy", route: "/", state: {"dayState":"lowEnergy"}, position: {"x":1560,"y":6160} },
    scr_uznv73: { name: "Home · Strong Day", route: "/", state: {"dayState":"strongDay"}, position: {"x":2960,"y":6160} },
    scr_obo27m: { name: "Home · First Use", route: "/", state: {"dayState":"firstUse"}, position: {"x":4360,"y":6160} },
    scr_0y7t1a: { name: "Daily Check · Partial", route: "/check", state: {"dayState":"inProgress"}, position: {"x":160,"y":8140} },
    scr_jzzkah: { name: "Daily Check · Low Energy", route: "/check", state: {"dayState":"lowEnergy"}, position: {"x":1560,"y":8140} },
    scr_1o1zn4: { name: "Daily Check · Complete", route: "/check", state: {"dayState":"strongDay"}, position: {"x":2960,"y":8140} },
    scr_1m25m9: { name: "Daily Check · First Use", route: "/check", state: {"dayState":"firstUse"}, position: {"x":4360,"y":8140} },
    scr_th3vx4: { name: "Community · For You", route: "/comunidade", state: {"communityTab":"feed"}, position: {"x":160,"y":10120} },
    scr_01mswi: { name: "Community · Communities", route: "/comunidade", state: {"communityTab":"communities"}, position: {"x":1560,"y":10120} },
    scr_hqfh9c: { name: "Community · Discover", route: "/comunidade", state: {"communityTab":"discover"}, position: {"x":2960,"y":10120} },
    scr_orvdqj: { name: "Community Detail", route: "/comunidade/c/corrida", position: {"x":4360,"y":10120} },
    scr_rf2gxp: { name: "Community Detail · Challenges", route: "/comunidade/c/corrida", state: {"detailTab":"challenges"}, position: {"x":5760,"y":10120} },
    scr_f0ki7q: { name: "Challenge Photo · Pose Guide", route: "/desafios/ch-mobility-pose/foto", position: {"x":160,"y":59620} },
    scr_wc2jnh: { name: "Search", route: "/busca", position: {"x":160,"y":12100} },
    scr_xz67ha: { name: "Pulse Viewer", route: "/pulse/pulse-lucas", position: {"x":160,"y":14080} },
    scr_9i11ua: { name: "Post Detail", route: "/post/p1", position: {"x":1560,"y":14080} },
    scr_1i5655: { name: "Comments", route: "/post/p1/comentarios", position: {"x":2960,"y":14080} },
    scr_h7kh05: { name: "Public Profile", route: "/u/lucas.corre", position: {"x":4360,"y":14080} },
    scr_8gdv7l: { name: "Notification Center", route: "/notificacoes", position: {"x":160,"y":16060} },
    scr_ansu06: { name: "Create Menu", route: "/novo", state: {"dayState":"inProgress"}, position: {"x":160,"y":18040} },
    scr_q2azte: { name: "Create · First-Day Post", route: "/novo", state: {"dayState":"firstUse"}, position: {"x":1560,"y":18040} },
    scr_tfiifw: { name: "Create · Locked Post", route: "/novo", state: {"dayState":"lowEnergy"}, position: {"x":2960,"y":18040} },
    scr_s7tzno: { name: "Create Pulse", route: "/novo/pulse", position: {"x":4360,"y":18040} },
    scr_bd72p6: { name: "Create Post", route: "/novo/post", state: {"dayState":"inProgress"}, position: {"x":5760,"y":18040} },
    scr_005q7t: { name: "Publish Success · Post", route: "/publicado/post", position: {"x":160,"y":20020} },
    scr_tovf9e: { name: "Publish Success · Pulse", route: "/publicado/pulse", position: {"x":1560,"y":20020} },
    scr_yext57: { name: "Progress Overview", route: "/stats", position: {"x":160,"y":22000} },
    scr_opxeko: { name: "Life Score Detail", route: "/stats/lifescore", position: {"x":1560,"y":22000} },
    scr_wbyl3z: { name: "90-Day Heatmap", route: "/stats/heatmap", position: {"x":2960,"y":22000} },
    scr_ymkrab: { name: "Weekly Review", route: "/stats/revisao", position: {"x":4360,"y":22000} },
    scr_ki0z3d: { name: "Mood Insights", route: "/stats/humor", position: {"x":5760,"y":22000} },
    scr_gx666s: { name: "Goals", route: "/stats/metas", position: {"x":7160,"y":22000} },
    scr_hbx125: { name: "Streak Protection", route: "/stats/protecao", position: {"x":8560,"y":22000} },
    scr_h5keq3: { name: "Monthly Recap · Intro", route: "/stats/retrospectiva", state: {"recapPeriod":"month","recapStep":"intro"}, position: {"x":9960,"y":22000} },
    scr_bpu7k1: { name: "Monthly Recap · Bee Type", route: "/stats/retrospectiva", state: {"recapPeriod":"month","recapStep":"beeType"}, position: {"x":14160,"y":22000} },
    scr_g7jlj3: { name: "Monthly Recap · Hive Evolution", route: "/stats/retrospectiva", state: {"recapPeriod":"month","recapStep":"hive"}, position: {"x":15560,"y":22000} },
    scr_wrs6hc: { name: "Monthly Recap · Social Highlight", route: "/stats/retrospectiva", state: {"recapPeriod":"month","recapStep":"social"}, position: {"x":16960,"y":22000} },
    scr_tjkhxl: { name: "Monthly Recap · Community Consistency", route: "/stats/retrospectiva", state: {"recapPeriod":"month","recapStep":"percentile"}, position: {"x":18360,"y":22000} },
    scr_a6w2zo: { name: "Monthly Recap · Share Card", route: "/stats/retrospectiva", state: {"recapPeriod":"month","recapStep":"share"}, position: {"x":19760,"y":22000} },
    scr_v424co: { name: "Annual Recap · Bee Type (Balance)", route: "/stats/retrospectiva", state: {"recapPeriod":"year","recapStep":"beeType"}, position: {"x":21160,"y":22000} },
    scr_xty9mu: { name: "Annual Recap · Hive Evolution", route: "/stats/retrospectiva", state: {"recapPeriod":"year","recapStep":"hive"}, position: {"x":22560,"y":22000} },
    scr_2lg34a: { name: "Annual Recap · Milestones", route: "/stats/retrospectiva", state: {"recapPeriod":"year","recapStep":"milestones"}, position: {"x":23960,"y":22000} },
    scr_en4vqq: { name: "Annual Recap · Share Card", route: "/stats/retrospectiva", state: {"recapPeriod":"year","recapStep":"share"}, position: {"x":25360,"y":22000} },
    scr_9bvqjb: { name: "Life Score Share Card", route: "/stats/compartilhar", position: {"x":11360,"y":22000} },
    scr_ytafm7: { name: "Weekly League", route: "/stats/liga", position: {"x":12760,"y":22000} },
    scr_z028sd: { name: "Profile", route: "/perfil", position: {"x":160,"y":23980} },
    scr_84mrpm: { name: "Edit Profile", route: "/perfil/editar", position: {"x":1560,"y":23980} },
    scr_nez0v1: { name: "Own Public Profile", route: "/perfil/publico", position: {"x":2960,"y":23980} },
    scr_b1tuck: { name: "Public Metrics", route: "/perfil/publicas", position: {"x":4360,"y":23980} },
    scr_4ezno4: { name: "Minha Colmeia", route: "/perfil/colmeia", position: {"x":5760,"y":23980} },
    scr_ybycct: { name: "Progress Photos", route: "/perfil/fotos", position: {"x":7160,"y":23980} },
    scr_goun35: { name: "Before and After", route: "/perfil/fotos/antes-depois", position: {"x":8560,"y":23980} },
    scr_dc8fid: { name: "Health", route: "/perfil/saude", position: {"x":160,"y":25960} },
    scr_7adwqp: { name: "Biomarkers", route: "/perfil/saude/biomarcadores", position: {"x":1560,"y":25960} },
    scr_s7vie5: { name: "Testosterone", route: "/perfil/saude/biomarcadores/testosteroneTotal", position: {"x":2960,"y":25960} },
    scr_27ypzh: { name: "Body Metrics", route: "/perfil/corpo", position: {"x":160,"y":27940} },
    scr_skxtkw: { name: "Edit Body Metrics", route: "/perfil/corpo/editar", position: {"x":1560,"y":27940} },
    scr_6v6dhf: { name: "Running", route: "/perfil/esportes/running", position: {"x":160,"y":29920} },
    scr_dukab7: { name: "Cycling", route: "/perfil/esportes/cycling", position: {"x":1560,"y":29920} },
    scr_1mq5wt: { name: "Swimming", route: "/perfil/esportes/swimming", position: {"x":2960,"y":29920} },
    scr_t2i0hp: { name: "CrossFit", route: "/perfil/esportes/crossfit", position: {"x":4360,"y":29920} },
    scr_pun43s: { name: "Strength", route: "/perfil/esportes/strength", position: {"x":5760,"y":29920} },
    scr_8zdwxm: { name: "Progress Chart · Body", route: "/perfil/grafico/body", position: {"x":160,"y":31900} },
    scr_713fto: { name: "Progress Chart · Weight", route: "/perfil/grafico/weight", position: {"x":1560,"y":31900} },
    scr_7tvwur: { name: "Settings", route: "/config", position: {"x":160,"y":33880} },
    scr_n9cigc: { name: "Account", route: "/config/conta", position: {"x":1560,"y":33880} },
    scr_npn5pj: { name: "Language Settings", route: "/config/idioma", position: {"x":2960,"y":33880} },
    scr_ykthgp: { name: "Units", route: "/config/unidades", position: {"x":4360,"y":33880} },
    scr_33e63o: { name: "Notification Preferences", route: "/config/notificacoes", position: {"x":5760,"y":33880} },
    scr_9ifymj: { name: "Smart Reminders", route: "/config/notificacoes/lembretes", position: {"x":18360,"y":33880} },
    scr_7qo219: { name: "Privacy", route: "/config/privacidade", position: {"x":7160,"y":33880} },
    scr_s1z0gm: { name: "Security", route: "/config/seguranca", position: {"x":8560,"y":33880} },
    scr_g3f0r7: { name: "Active Sessions", route: "/config/sessoes", position: {"x":9960,"y":33880} },
    scr_5tk876: { name: "Accessibility", route: "/config/acessibilidade", position: {"x":11360,"y":33880} },
    scr_qkdhys: { name: "Connected Services", route: "/config/servicos", position: {"x":12760,"y":33880} },
    scr_bp4gvn: { name: "Help & Support", route: "/config/ajuda", position: {"x":14160,"y":33880} },
    scr_xex0xj: { name: "Export My Data", route: "/config/dados", position: {"x":15560,"y":33880} },
    scr_jvwkmf: { name: "Delete Account", route: "/config/excluir", position: {"x":16960,"y":33880} },
    scr_9blnns: { name: "App States Gallery", route: "/estados", position: {"x":160,"y":35860} },
    scr_wq6ny8: { name: "State · Loading", route: "/estado/skeleton", position: {"x":1560,"y":35860} },
    scr_cu6s33: { name: "State · Offline", route: "/estado/offline", position: {"x":2960,"y":35860} },
    scr_od7yfa: { name: "State · Error", route: "/estado/error", position: {"x":4360,"y":35860} },
    scr_w75mvv: { name: "State · Empty", route: "/estado/empty", position: {"x":5760,"y":35860} },
    scr_av7736: { name: "State · Session Expired", route: "/estado/session", position: {"x":7160,"y":35860} },
    scr_w2snmj: { name: "State · Maintenance", route: "/estado/maintenance", position: {"x":8560,"y":35860} },
    scr_veabme: { name: "State · Update Available", route: "/estado/update", position: {"x":9960,"y":35860} },
    scr_z3fvo5: { name: "State · Camera Denied", route: "/estado/camera", position: {"x":11360,"y":35860} },
    scr_29putw: { name: "State · Notifications Denied", route: "/estado/notifications", position: {"x":12760,"y":35860} },
    scr_99r1i4: { name: "State · Location Denied", route: "/estado/location", position: {"x":14160,"y":35860} },
    scr_ehyd89: { name: "State · Photos Denied", route: "/estado/photos", position: {"x":15560,"y":35860} },
    scr_uxt0l4: { name: "Admin · Login", route: "/admin/login", position: {"x":160,"y":37840} },
    scr_x44y8j: { name: "Admin · Dashboard", route: "/admin", position: {"x":160,"y":39820} },
    scr_s7g4p8: { name: "Admin · Users", route: "/admin/usuarios", position: {"x":160,"y":41800} },
    scr_2a79r6: { name: "Admin · User Detail", route: "/admin/usuarios/u1", position: {"x":1560,"y":41800} },
    scr_058q2c: { name: "Admin · Posts Moderation", route: "/admin/moderacao/post", position: {"x":160,"y":43780} },
    scr_4v615q: { name: "Admin · Pulses Moderation", route: "/admin/moderacao/pulse", position: {"x":1560,"y":43780} },
    scr_oij2xq: { name: "Admin · Comments Moderation", route: "/admin/moderacao/comment", position: {"x":2960,"y":43780} },
    scr_116d20: { name: "Admin · Reports Queue", route: "/admin/denuncias", position: {"x":160,"y":45760} },
    scr_un0bxu: { name: "Admin · Report Detail", route: "/admin/denuncias/R-2841", position: {"x":1560,"y":45760} },
    scr_6p3cs1: { name: "Admin · Daily Check Analytics", route: "/admin/daily-check", position: {"x":160,"y":47740} },
    scr_g6urz0: { name: "Admin · Bee Analytics", route: "/admin/gamificacao/xp", position: {"x":1560,"y":47740} },
    scr_duej0w: { name: "Admin · Levels", route: "/admin/gamificacao/niveis", position: {"x":160,"y":49720} },
    scr_d135i0: { name: "Admin · Streaks", route: "/admin/gamificacao/sequencias", position: {"x":1560,"y":49720} },
    scr_yv18ow: { name: "Admin · Badges", route: "/admin/gamificacao/medalhas", position: {"x":2960,"y":49720} },
    scr_m54rfe: { name: "Admin · Challenges", route: "/admin/gamificacao/desafios", position: {"x":4360,"y":49720} },
    scr_evbalo: { name: "Admin · Recap Configuration", route: "/admin/gamificacao/retrospectiva", position: {"x":5760,"y":49720} },
    scr_074xjg: { name: "Admin · Sports Analytics", route: "/admin/performance", position: {"x":2960,"y":47740} },
    scr_ndxbxj: { name: "Admin · Community Analytics", route: "/admin/comunidade", position: {"x":4360,"y":47740} },
    scr_52ti9f: { name: "Admin · Notifications", route: "/admin/notificacoes", position: {"x":160,"y":51700} },
    scr_jnwjwx: { name: "Admin · Create Notification", route: "/admin/notificacoes/nova", position: {"x":1560,"y":51700} },
    scr_78cj8x: { name: "Admin · Content Management", route: "/admin/conteudo", position: {"x":2960,"y":51700} },
    scr_nbqyu4: { name: "Admin · Reports & Export", route: "/admin/relatorios", position: {"x":4360,"y":51700} },
    scr_v8rzxu: { name: "Admin · Team", route: "/admin/equipe", position: {"x":160,"y":53680} },
    scr_53mm55: { name: "Admin · Roles", route: "/admin/papeis", position: {"x":1560,"y":53680} },
    scr_bx8qve: { name: "Admin · Permission Matrix", route: "/admin/papeis/matriz", position: {"x":2960,"y":53680} },
    scr_hcwih6: { name: "Admin · Audit Log", route: "/admin/auditoria", position: {"x":4360,"y":53680} },
    scr_8djoqi: { name: "Admin · General Settings", route: "/admin/config/geral", position: {"x":160,"y":55660} },
    scr_siqbap: { name: "Admin · Security Settings", route: "/admin/config/seguranca", position: {"x":1560,"y":55660} },
    scr_yn7k9a: { name: "Admin · Integration Settings", route: "/admin/config/integracoes", position: {"x":2960,"y":55660} },
    scr_1jhzkq: { name: "Admin · Maintenance", route: "/admin/config/manutencao", position: {"x":4360,"y":55660} },
    scr_5s9vag: { name: "Admin · Hidratação", route: "/admin/config/hidratacao", position: {"x":5760,"y":55660} },
    scr_sdywof: { name: "Admin · State Gallery", route: "/admin/estados", position: {"x":160,"y":57640} },
    scr_c03vdp: { name: "Client Review / Brand Concepts", route: "/marca/conceitos", position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_w5dcko: { name: "Splash & Language", x: 0, y: 0, width: 2920, height: 1180 },
    sec_jcdc5f: { name: "Authentication", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_63hxcs: { name: "Onboarding", x: 0, y: 3960, width: 9920, height: 1180 },
    sec_xjtcdc: { name: "Home", x: 0, y: 5940, width: 5720, height: 1180 },
    sec_3ezcz9: { name: "Daily Check", x: 0, y: 7920, width: 5720, height: 1180 },
    sec_62cwak: { name: "Community", x: 0, y: 9900, width: 7120, height: 1180 },
    sec_uaykh5: { name: "Search", x: 0, y: 11880, width: 1520, height: 1180 },
    sec_byzzbr: { name: "Social Content", x: 0, y: 13860, width: 5720, height: 1180 },
    sec_zc8dm4: { name: "Notifications", x: 0, y: 15840, width: 1520, height: 1180 },
    sec_vs64uj: { name: "Create", x: 0, y: 17820, width: 7120, height: 1180 },
    sec_ert0bj: { name: "Publish Success", x: 0, y: 19800, width: 2920, height: 1180 },
    sec_hqhg4m: { name: "Statistics", x: 0, y: 21780, width: 26720, height: 1180 },
    sec_wf68xm: { name: "Profile", x: 0, y: 23760, width: 9920, height: 1180 },
    sec_jo5ry4: { name: "Health & Biomarkers", x: 0, y: 25740, width: 4320, height: 1180 },
    sec_0e12fm: { name: "Body Metrics", x: 0, y: 27720, width: 2920, height: 1180 },
    sec_mfxmce: { name: "Sports", x: 0, y: 29700, width: 7120, height: 1180 },
    sec_wqzrn1: { name: "Progress Charts", x: 0, y: 31680, width: 2920, height: 1180 },
    sec_960quu: { name: "Settings", x: 0, y: 33660, width: 19720, height: 1180 },
    sec_3mwcs6: { name: "App States", x: 0, y: 35640, width: 16920, height: 1180 },
    sec_jows1a: { name: "Admin Authentication", x: 0, y: 37620, width: 1520, height: 1180 },
    sec_q0xacb: { name: "Admin Dashboard", x: 0, y: 39600, width: 1520, height: 1180 },
    sec_h3vsxy: { name: "Admin Users", x: 0, y: 41580, width: 2920, height: 1180 },
    sec_20cxs1: { name: "Admin Moderation", x: 0, y: 43560, width: 4320, height: 1180 },
    sec_k05i8x: { name: "Admin Reports", x: 0, y: 45540, width: 2920, height: 1180 },
    sec_da54nu: { name: "Admin Analytics", x: 0, y: 47520, width: 5720, height: 1180 },
    sec_qrqh8b: { name: "Admin Gamification", x: 0, y: 49500, width: 7120, height: 1180 },
    sec_81rwko: { name: "Admin Content", x: 0, y: 51480, width: 5720, height: 1180 },
    sec_uqpxuc: { name: "Admin Team", x: 0, y: 53460, width: 5720, height: 1180 },
    sec_hp07s2: { name: "Admin Settings", x: 0, y: 55440, width: 7120, height: 1180 },
    sec_tfcqhh: { name: "Admin States", x: 0, y: 57420, width: 1520, height: 1180 },
    sec_2fxr8d: { name: "Challenge Photo", x: 0, y: 59400, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_w5dcko", children: [
      { kind: "screen", id: "scr_haiat8" },
      { kind: "screen", id: "scr_vw8blx" },
    ] },
    { kind: "section", id: "sec_jcdc5f", children: [
      { kind: "screen", id: "scr_xub3oe" },
      { kind: "screen", id: "scr_gmstpe" },
      { kind: "screen", id: "scr_qzzu98" },
      { kind: "screen", id: "scr_87biud" },
    ] },
    { kind: "section", id: "sec_63hxcs", children: [
      { kind: "screen", id: "scr_kul27o" },
      { kind: "screen", id: "scr_wv5vhi" },
      { kind: "screen", id: "scr_qa8zqt" },
      { kind: "screen", id: "scr_skbrwk" },
      { kind: "screen", id: "scr_3ft68j" },
      { kind: "screen", id: "scr_9ufhsf" },
      { kind: "screen", id: "scr_6wfrz7" },
    ] },
    { kind: "section", id: "sec_xjtcdc", children: [
      { kind: "screen", id: "scr_3xmww3" },
      { kind: "screen", id: "scr_nuvdw7" },
      { kind: "screen", id: "scr_uznv73" },
      { kind: "screen", id: "scr_obo27m" },
    ] },
    { kind: "section", id: "sec_3ezcz9", children: [
      { kind: "screen", id: "scr_0y7t1a" },
      { kind: "screen", id: "scr_jzzkah" },
      { kind: "screen", id: "scr_1o1zn4" },
      { kind: "screen", id: "scr_1m25m9" },
    ] },
    { kind: "section", id: "sec_62cwak", children: [
      { kind: "screen", id: "scr_th3vx4" },
      { kind: "screen", id: "scr_01mswi" },
      { kind: "screen", id: "scr_hqfh9c" },
      { kind: "screen", id: "scr_orvdqj" },
      { kind: "screen", id: "scr_rf2gxp" },
    ] },
    { kind: "section", id: "sec_uaykh5", children: [
      { kind: "screen", id: "scr_wc2jnh" },
    ] },
    { kind: "section", id: "sec_byzzbr", children: [
      { kind: "screen", id: "scr_xz67ha" },
      { kind: "screen", id: "scr_9i11ua" },
      { kind: "screen", id: "scr_1i5655" },
      { kind: "screen", id: "scr_h7kh05" },
    ] },
    { kind: "section", id: "sec_zc8dm4", children: [
      { kind: "screen", id: "scr_8gdv7l" },
    ] },
    { kind: "section", id: "sec_vs64uj", children: [
      { kind: "screen", id: "scr_ansu06" },
      { kind: "screen", id: "scr_q2azte" },
      { kind: "screen", id: "scr_tfiifw" },
      { kind: "screen", id: "scr_s7tzno" },
      { kind: "screen", id: "scr_bd72p6" },
    ] },
    { kind: "section", id: "sec_ert0bj", children: [
      { kind: "screen", id: "scr_005q7t" },
      { kind: "screen", id: "scr_tovf9e" },
    ] },
    { kind: "section", id: "sec_hqhg4m", children: [
      { kind: "screen", id: "scr_yext57" },
      { kind: "screen", id: "scr_opxeko" },
      { kind: "screen", id: "scr_wbyl3z" },
      { kind: "screen", id: "scr_ymkrab" },
      { kind: "screen", id: "scr_ki0z3d" },
      { kind: "screen", id: "scr_gx666s" },
      { kind: "screen", id: "scr_hbx125" },
      { kind: "screen", id: "scr_h5keq3" },
      { kind: "screen", id: "scr_9bvqjb" },
      { kind: "screen", id: "scr_ytafm7" },
      { kind: "screen", id: "scr_bpu7k1" },
      { kind: "screen", id: "scr_g7jlj3" },
      { kind: "screen", id: "scr_wrs6hc" },
      { kind: "screen", id: "scr_tjkhxl" },
      { kind: "screen", id: "scr_a6w2zo" },
      { kind: "screen", id: "scr_v424co" },
      { kind: "screen", id: "scr_xty9mu" },
      { kind: "screen", id: "scr_2lg34a" },
      { kind: "screen", id: "scr_en4vqq" },
    ] },
    { kind: "section", id: "sec_wf68xm", children: [
      { kind: "screen", id: "scr_z028sd" },
      { kind: "screen", id: "scr_84mrpm" },
      { kind: "screen", id: "scr_nez0v1" },
      { kind: "screen", id: "scr_b1tuck" },
      { kind: "screen", id: "scr_4ezno4" },
      { kind: "screen", id: "scr_ybycct" },
      { kind: "screen", id: "scr_goun35" },
    ] },
    { kind: "section", id: "sec_jo5ry4", children: [
      { kind: "screen", id: "scr_dc8fid" },
      { kind: "screen", id: "scr_7adwqp" },
      { kind: "screen", id: "scr_s7vie5" },
    ] },
    { kind: "section", id: "sec_0e12fm", children: [
      { kind: "screen", id: "scr_27ypzh" },
      { kind: "screen", id: "scr_skxtkw" },
    ] },
    { kind: "section", id: "sec_mfxmce", children: [
      { kind: "screen", id: "scr_6v6dhf" },
      { kind: "screen", id: "scr_dukab7" },
      { kind: "screen", id: "scr_1mq5wt" },
      { kind: "screen", id: "scr_t2i0hp" },
      { kind: "screen", id: "scr_pun43s" },
    ] },
    { kind: "section", id: "sec_wqzrn1", children: [
      { kind: "screen", id: "scr_8zdwxm" },
      { kind: "screen", id: "scr_713fto" },
    ] },
    { kind: "section", id: "sec_960quu", children: [
      { kind: "screen", id: "scr_7tvwur" },
      { kind: "screen", id: "scr_n9cigc" },
      { kind: "screen", id: "scr_npn5pj" },
      { kind: "screen", id: "scr_ykthgp" },
      { kind: "screen", id: "scr_33e63o" },
      { kind: "screen", id: "scr_7qo219" },
      { kind: "screen", id: "scr_s1z0gm" },
      { kind: "screen", id: "scr_g3f0r7" },
      { kind: "screen", id: "scr_5tk876" },
      { kind: "screen", id: "scr_qkdhys" },
      { kind: "screen", id: "scr_bp4gvn" },
      { kind: "screen", id: "scr_xex0xj" },
      { kind: "screen", id: "scr_jvwkmf" },
      { kind: "screen", id: "scr_9ifymj" },
    ] },
    { kind: "section", id: "sec_3mwcs6", children: [
      { kind: "screen", id: "scr_9blnns" },
      { kind: "screen", id: "scr_wq6ny8" },
      { kind: "screen", id: "scr_cu6s33" },
      { kind: "screen", id: "scr_od7yfa" },
      { kind: "screen", id: "scr_w75mvv" },
      { kind: "screen", id: "scr_av7736" },
      { kind: "screen", id: "scr_w2snmj" },
      { kind: "screen", id: "scr_veabme" },
      { kind: "screen", id: "scr_z3fvo5" },
      { kind: "screen", id: "scr_29putw" },
      { kind: "screen", id: "scr_99r1i4" },
      { kind: "screen", id: "scr_ehyd89" },
    ] },
    { kind: "section", id: "sec_jows1a", children: [
      { kind: "screen", id: "scr_uxt0l4" },
    ] },
    { kind: "section", id: "sec_q0xacb", children: [
      { kind: "screen", id: "scr_x44y8j" },
    ] },
    { kind: "section", id: "sec_h3vsxy", children: [
      { kind: "screen", id: "scr_s7g4p8" },
      { kind: "screen", id: "scr_2a79r6" },
    ] },
    { kind: "section", id: "sec_20cxs1", children: [
      { kind: "screen", id: "scr_058q2c" },
      { kind: "screen", id: "scr_4v615q" },
      { kind: "screen", id: "scr_oij2xq" },
    ] },
    { kind: "section", id: "sec_k05i8x", children: [
      { kind: "screen", id: "scr_116d20" },
      { kind: "screen", id: "scr_un0bxu" },
    ] },
    { kind: "section", id: "sec_da54nu", children: [
      { kind: "screen", id: "scr_6p3cs1" },
      { kind: "screen", id: "scr_g6urz0" },
      { kind: "screen", id: "scr_074xjg" },
      { kind: "screen", id: "scr_ndxbxj" },
    ] },
    { kind: "section", id: "sec_qrqh8b", children: [
      { kind: "screen", id: "scr_duej0w" },
      { kind: "screen", id: "scr_d135i0" },
      { kind: "screen", id: "scr_yv18ow" },
      { kind: "screen", id: "scr_m54rfe" },
      { kind: "screen", id: "scr_evbalo" },
    ] },
    { kind: "section", id: "sec_81rwko", children: [
      { kind: "screen", id: "scr_52ti9f" },
      { kind: "screen", id: "scr_jnwjwx" },
      { kind: "screen", id: "scr_78cj8x" },
      { kind: "screen", id: "scr_nbqyu4" },
    ] },
    { kind: "section", id: "sec_uqpxuc", children: [
      { kind: "screen", id: "scr_v8rzxu" },
      { kind: "screen", id: "scr_53mm55" },
      { kind: "screen", id: "scr_bx8qve" },
      { kind: "screen", id: "scr_hcwih6" },
    ] },
    { kind: "section", id: "sec_hp07s2", children: [
      { kind: "screen", id: "scr_8djoqi" },
      { kind: "screen", id: "scr_siqbap" },
      { kind: "screen", id: "scr_yn7k9a" },
      { kind: "screen", id: "scr_1jhzkq" },
      { kind: "screen", id: "scr_5s9vag" },
    ] },
    { kind: "section", id: "sec_tfcqhh", children: [
      { kind: "screen", id: "scr_sdywof" },
    ] },
    { kind: "screen", id: "scr_c03vdp" },
    { kind: "section", id: "sec_2fxr8d", children: [
      { kind: "screen", id: "scr_f0ki7q" },
    ] },
  ],
}
